import api, { getAuthParams } from './client';

export const getSecFilingsMeta = (params) =>
  api.get('/sec-filings/meta', { params: { ...getAuthParams(), ...params } });

export const getSecFilingOptions = (params) =>
  api.get('/sec-filings/options', { params: { ...getAuthParams(), ...params } });

export const getSecFilingsScopeConfig = (params) =>
  api.get('/sec-filings/scope-config', { params: { ...getAuthParams(), ...params } });

export const getSecFilingSnapshots = (params) =>
  api.post('/sec-filings/snapshots', { ...getAuthParams(), ...params });

export const getSecFilingInsights = (payload) =>
  api.post('/sec-filings/insights', { ...getAuthParams(), ...payload });
